import { DEMO } from "./demo/demoMode";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// طبقة التجاوب المركزية بعد Tailwind وأنماط النظام
import "./styles/responsive.css";
import "./i18n";
import App from "./App";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// نسخة العرض تُستضاف تحت مسار فرعي، فتستعمل روابط # بدل مسارات الخادم
const Router = DEMO ? HashRouter : BrowserRouter;


const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <Router>
      <App />
      {DEMO && (
        <div
          dir="rtl"
          style={{
            position: "fixed", bottom: 12, left: 12, zIndex: 99999,
            background: "#2A385B", color: "#fff", padding: "6px 12px",
            borderRadius: 8, fontSize: 12, boxShadow: "0 2px 8px rgba(0,0,0,.25)",
            pointerEvents: "none",
          }}
        >
          نسخة عرض — ادخل بأي اسم وكلمة مرور، والبيانات غير حقيقية
        </div>
      )}
    </Router>
  </QueryClientProvider>
);
